import { render, staticRenderFns } from "./widget-hidden-icon.vue?vue&type=template&id=35e4f7f4&scoped=true"
import script from "./widget-hidden-icon.vue?vue&type=script&lang=js"
export * from "./widget-hidden-icon.vue?vue&type=script&lang=js"
import style0 from "./widget-hidden-icon.vue?vue&type=style&index=0&id=35e4f7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e4f7f4",
  null
  
)

export default component.exports